import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export interface CheckSuccessIconProps {
  size?: number | string
  fillColor?: string
  backgroundColor?: string
  accessibilityLabel?: string
}

export const CheckSuccessIcon: FunctionComponent<CheckSuccessIconProps> = ({
  size = 24,
  fillColor,
  backgroundColor,
  accessibilityLabel,
}) => {
  const { colors } = useTheme() as ThemeType

  return (
    <Svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      testID={tID('CheckSuccessIcon')}
      accessibilityLabel={accessibilityLabel}
      accessible={!!accessibilityLabel}
    >
      <Path
        d='M12 23.8728C18.6274 23.8728 24 18.5287 24 11.9364C24 5.34411 18.6274 0 12 0C5.37258 0 0 5.34411 0 11.9364C0 18.5287 5.37258 23.8728 12 23.8728Z'
        fill={backgroundColor || colors.backgroundSuccess}
      />
      <Path
        d='M11.3206 18.8322C10.9781 18.8437 10.6898 18.7238 10.4113 18.5745C9.97201 18.3388 9.56339 18.055 9.16047 17.7637C8.75929 17.4736 8.36394 17.1753 7.96858 16.877C7.66398 16.6471 7.35987 16.4163 7.06196 16.178C6.54287 15.7628 6.02293 15.3476 5.56186 14.8665C5.41223 14.7103 5.26953 14.545 5.19589 14.3349C5.09411 14.0445 5.13688 13.7717 5.2916 13.5097C5.50248 13.1528 5.77671 12.8471 6.06384 12.5529C6.2467 12.3654 6.43551 12.1826 6.63437 12.0125C6.74247 11.92 6.87166 11.847 7.00096 11.7854C7.19387 11.6934 7.39532 11.7182 7.59257 11.7837C7.80593 11.8547 8.00255 11.9614 8.18579 12.0882C8.55907 12.3466 8.92703 12.6128 9.29536 12.8783C9.66183 13.1425 10.0252 13.4108 10.3915 13.6751C10.4751 13.7354 10.564 13.7887 10.6525 13.8415C10.7462 13.8974 10.7767 13.8929 10.8481 13.8078C10.9236 13.7177 10.9984 13.6264 11.0655 13.5299C11.3884 13.0654 11.7078 12.5984 12.03 12.1334C12.2639 11.7956 12.4989 11.4587 12.7355 11.123C13.0843 10.6285 13.435 10.1354 13.7851 9.64183C14.1089 9.18536 14.4304 8.72727 14.7576 8.27328C15.0002 7.93656 15.2461 7.6022 15.4986 7.27293C15.6137 7.12267 15.7423 6.98159 15.8747 6.84584C16.1409 6.57297 16.4661 6.51693 16.8149 6.63991C17.0218 6.71281 17.2189 6.81683 17.4146 6.91824C17.6142 7.02176 17.8087 7.13556 18.0016 7.25136C18.2813 7.41922 18.561 7.58869 18.7978 7.81631C18.8714 7.8871 18.9382 7.96818 18.9943 8.0536C19.1051 8.2227 19.0845 8.40382 19.0172 8.58297C18.9143 8.85658 18.7712 9.11048 18.6216 9.36004C18.3891 9.74783 18.154 10.134 17.9122 10.516C17.6738 10.8926 17.4265 11.2637 17.1816 11.6363C16.9177 12.0383 16.6547 12.4409 16.3867 12.84C16.0184 13.3882 15.6479 13.9351 15.2739 14.4795C14.9583 14.9388 14.6397 15.396 14.3161 15.8497C14.0358 16.2429 13.754 16.6354 13.4592 17.0176C13.1858 17.3722 12.8984 17.7162 12.6093 18.0582C12.4334 18.2663 12.2378 18.4563 12.0188 18.6211C11.8063 18.781 11.5669 18.8452 11.3209 18.8322H11.3206Z'
        fill={fillColor || colors.textSuccess}
      />
    </Svg>
  )
}
